module.exports = __webpack_public_path__ + "img/market.446a7606.png";